import type { IconName, TabId } from "@blueprintjs/core";
import type React from "react";
import type { MenuItem } from "../../layout/AdminMenuItems";
import { generatorPathItem } from "./GeneratorPath";
import { GeneratorPanel } from "./GeneratorPanel";
import { GeneratorUsersPanel } from "./GeneratorUsersPanel";
import { GeneratorVehiclesPanel } from "./GeneratorVehiclesPanel";

export const generatorTabs: Record<
  TabId,
  {
    label: string;
    panel: React.JSX.Element;
    description: string;
    icon: IconName;
  }
> = {
  root: {
    label: "Generator",
    panel: <GeneratorPanel />,
    description: "Generate synthetic test reports from the saved users and vehicles",
    icon: "new-layers",
  },
  users: {
    label: "Users",
    panel: <GeneratorUsersPanel />,
    description: "Manage the saved pool of users available for generation",
    icon: "person",
  },
  vehicles: {
    label: "Vehicles",
    panel: <GeneratorVehiclesPanel />,
    description: "Manage the saved pool of vehicles available for generation",
    icon: "drive-time",
  },
};

function generatorChildName(name: string) {
  return `${generatorPathItem.label} → ${name}`;
}

export function generatorPathName(tabId: TabId) {
  return tabId === "root" ? generatorPathItem.path : `${generatorPathItem.path}/${tabId}`;
}

export const generatorTabMenuItems: MenuItem[] = [
  ...Object.entries(generatorTabs).map(([key, value]) => {
    const item: MenuItem = {
      link: { pathname: generatorPathName(key) },
      icon: value.icon,
      description: value.description,
      title: generatorChildName(value.label),
      hideInProduction: true,
    };
    return item;
  }),
];
